import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CoachCard } from '@widgets/coaches';
import { Description, Diploma } from '@features/coaches';
import { useUser } from '@shared/hooks';
import { LargeHeader } from '@shared/ui';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import { Loader, ModalLarge } from '@src/library/components/common';
import * as st from './styles.module.scss';

export const CoachModal: React.FC = () => {
  const { coachId } = useParams<{ [x: string]: string }>();
  const navigate = useNavigate();
  const id = Number(coachId);
  const { user } = useUser();

  const { isLoading } = useCoachQuery({ id: coachId });

  const onClose = () => navigate(-1);

  return (
    <ModalLarge isOpen disableHeader onRequestClose={onClose}>
      <LargeHeader title="Специалист" onClose={onClose} />
      {!isLoading ? (
        <div className={st.coach}>
          <CoachCard id={id} isAnotherCoachBuy={!user?.is_coach} isCardRedirect={false} />
          <Description id={id} />
          <Diploma id={id} />
        </div>
      ) : (
        <Loader />
      )}
    </ModalLarge>
  );
};
